import React from "react";

export default function ColorFrame48({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <ellipse
          cx="111.112"
          cy="262.448"
          fill="#DDD"
          rx="44.402"
          ry="11.552"
        ></ellipse>
        <path
          fill={fill}
          d="M195.223 86.952c0 46.918-84.111 173.52-84.111 173.52S27 133.87 27 86.952C27 40.034 64.658 2 111.112 2c46.453 0 84.111 38.034 84.111 84.952z"
        ></path>
        <ellipse
          cx="112.194"
          cy="88.638"
          fill="#fff"
          rx="33.212"
          ry="33.934"
        ></ellipse>
        <rect
          width="130.68"
          height="130.68"
          x="113.166"
          y="77.224"
          fill="#fff"
          stroke="#7A6FF7"
          strokeWidth="10.83"
          rx="14.079"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
